/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_To_My_AccountInputs */

const en_save_to_my_account = /** @type {(inputs: Save_To_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save to My Account`)
};

const es_save_to_my_account = /** @type {(inputs: Save_To_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar en Mi Cuenta`)
};

const fr_save_to_my_account = /** @type {(inputs: Save_To_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer sur Mon Compte`)
};

const de_save_to_my_account = /** @type {(inputs: Save_To_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In meinem Konto speichern`)
};

const ja_save_to_my_account = /** @type {(inputs: Save_To_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイアカウントに保存`)
};

const zh_save_to_my_account = /** @type {(inputs: Save_To_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存到我的帐户`)
};

const ar_save_to_my_account = /** @type {(inputs: Save_To_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حفظ في حسابي`)
};

const id_save_to_my_account = /** @type {(inputs: Save_To_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan ke Akun Saya`)
};

const it_save_to_my_account = /** @type {(inputs: Save_To_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva nel Mio Account`)
};

const ru_save_to_my_account = /** @type {(inputs: Save_To_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить в Мой Аккаунт`)
};

const pt_save_to_my_account = /** @type {(inputs: Save_To_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar na Minha Conta`)
};

const ko_save_to_my_account = /** @type {(inputs: Save_To_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 계정에 저장`)
};

/**
* | output |
* | --- |
* | "Save to My Account" |
*
* @param {Save_To_My_AccountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const save_to_my_account = /** @type {((inputs?: Save_To_My_AccountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_To_My_AccountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_save_to_my_account(inputs)
	if (locale === "es") return es_save_to_my_account(inputs)
	if (locale === "fr") return fr_save_to_my_account(inputs)
	if (locale === "de") return de_save_to_my_account(inputs)
	if (locale === "ja") return ja_save_to_my_account(inputs)
	if (locale === "zh") return zh_save_to_my_account(inputs)
	if (locale === "ar") return ar_save_to_my_account(inputs)
	if (locale === "id") return id_save_to_my_account(inputs)
	if (locale === "it") return it_save_to_my_account(inputs)
	if (locale === "ru") return ru_save_to_my_account(inputs)
	if (locale === "pt") return pt_save_to_my_account(inputs)
	return ko_save_to_my_account(inputs)
});